import { getLink } from "../../../utils/utils";

import translator from "./translator";

const content = {
  esp: (
    `
    <div class="poem">
      <p class="poem-block mb-3">
        Al manplato mia stel’ ekfalis, <br/>
        Mi demandis ŝin: «De kie vi?» <br/>
        Tamen stel’ pro laco svene palis, <br/>
        Ne respondis dekomence ŝi.
      </p>

      <p class="poem-block mb-3">
        Poste ŝia brilo plifortiĝis, <br/>
        Voĉ’ eksonis kvazaŭ sonoril’: <br/>
        «Kvankam la malgranda mi naskiĝis, <br/>
        Mi scipovas fari farojn mil.
      </p>

      <p class="poem-block mb-3">
        Mi plenumos ĉiun vian peton, <br/>
        Kiun vi deziras kun obstin’» <br/>
        -«Volas mi eternan am-impeton <br/>
        Kaj ke estu sana la patrin’.
      </p>

      <p class="poem-block mb-3">
        Ke sur nia Ter’ militvundita <br/>
        Nure steloj falu de ĉiel’, <br/>
        Kruelec’ okazu senprofita, <br/>
        Ĉie regu am’, fidem’ kaj bel’.
      </p>

      <p class="poem-block mb-3">
        Estu ĉiuj homoj bonanimaj, <br/>
        Fortaj kaj liberaj kiel mar’, <br/>
        Kaj aperu, vastaj kaj senlimaj, <br/>
        Horizontoj antaŭ la homar’.
      </p>

      <p class="poem-block mb-3">
        Oni herbon falĉu per falĉilo <br/>
        Kaj la birdoj kantu en plenĝoj’, <br/>
        Kaj la suna radianta brilo <br/>
        Post la pluv’ ridetu sur la voj’.
      </p>

      <p class="poem-block mb-3">
        Volas mi, ke firmu amikeco, <br/>
        Malaperu morno kaj malic’, <br/>
        Ke plensaĝa estu maljuneco <br/>
        Kaj plenpova nia juna vic’.
      </p>

      <p class="poem-block mb-3">
        Lignofajro nia ĉiam flamu, <br/>
        Estu ĉiam sana la patrin’, <br/>
        Miaj kantoj inter homoj famu, <br/>
        Amatino mia amu min»
      </p>

      <p class="poem-block mb-3">
        Longaj paroladoj estis vanaj, <br/>
        Ja malgranda estis la stelet’. <br/>
        Estingiĝis ŝi en miaj manoj, <br/>
        Restis sen respondo mia pet’.
      </p>
    </div>
    `
  )
}

const itemName = {
  esp: 'Steleto'
}

const item = {
  itemlink: getLink(itemName.esp),
  esp: {
    itemName: itemName.esp,
    itemContent: content.esp,
    itemVideo: ['7GsvZ5pasYk'],
    itemTranslator: `
      A. Dolskij <br/>
      ${translator.esp}
    `
  }
}

export default item;